"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARSE_ERROR_TYPE_TO_MESSAGE_KEY = exports.UPDATE_DATA_MODE_TO_MESSAGE_KEY = void 0;
const hooks_1 = require("../hooks");
const upload_file_options_1 = require("../models/upload-file-options");
exports.UPDATE_DATA_MODE_TO_MESSAGE_KEY = {
    [upload_file_options_1.UpdateDataModes.Replace]: 'REPLACE',
    [upload_file_options_1.UpdateDataModes.Merge]: 'MERGE',
};
exports.PARSE_ERROR_TYPE_TO_MESSAGE_KEY = {
    [hooks_1.ErrorTypes.Delimiter]: 'CSV_PARSE_ERROR_DELIMITER',
    [hooks_1.ErrorTypes.Quotes]: 'CSV_PARSE_ERROR_QUOTES',
    [hooks_1.ErrorTypes.FieldMismatch]: 'CSV_PARSE_ERROR_FIELD_MISMATCH',
    [hooks_1.ErrorTypes.DuplicatedKeyField]: 'CSV_PARSE_ERROR_DUPLICATED_KEY',
    [hooks_1.ErrorTypes.EmptyKeyField]: 'CSV_PARSE_ERROR_EMPTY_KEY',
    [hooks_1.ErrorTypes.EmptyField]: 'CSV_PARSE_ERROR_EMPTY',
    [hooks_1.ErrorTypes.ParseArray]: 'CSV_PARSE_ERROR_PARSE_ARRAY',
    [hooks_1.ErrorTypes.Parse]: 'CSV_PARSE_ERROR_PARSE',
};
